import { LayoutGrid, List as ListIcon } from "lucide-react";
import type { ViewMode } from "@/hooks/useViewMode";

const BORDER = "hsl(210,30%,85%)";
const ICON_COLOR = "hsl(215,16%,47%)";

export interface ViewToggleButtonProps {
  mode: ViewMode;
  onToggle: () => void;
  className?: string;
}

export function ViewToggleButton({
  mode,
  onToggle,
  className,
}: ViewToggleButtonProps) {
  const targetLabel = mode === "list" ? "Grid" : "List";
  const Icon = mode === "list" ? LayoutGrid : ListIcon;
  return (
    <button
      type="button"
      onClick={onToggle}
      title={`Switch to ${targetLabel} view`}
      aria-label={`Switch to ${targetLabel} view`}
      className={
        "inline-flex h-8 w-8 items-center justify-center rounded-md border bg-white transition-colors hover:bg-[hsl(210,30%,97%)]" +
        (className ? ` ${className}` : "")
      }
      style={{ borderColor: BORDER, color: ICON_COLOR }}
    >
      <Icon className="h-4 w-4" strokeWidth={1.5} />
    </button>
  );
}
